import Example from './Example';

export const ExampleConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/example',
            component: Example
        }
    ]
};



// WEBPACK FOOTER //
// src/main/content/example/ExampleConfig.js